import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function MAndERejectWidget({
  schema,
  isShow,
  onConfirm = () => {},
  onCancle = () => {},
  ...props
}) {
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const onSubmit = (data) => {
    console.log('onSubmit EvaluationMAndERejectWidget :', data)

    let req = {
      id: schema.id,
      type: 0,
      note: data.note,
    }

    onConfirm(req)
  }

  return (
    <>
      <ConfirmWidget
        title={schema.rejectBtn}
        show={isShow}
        size="md"
        detail={
          <>
            {schema.note && (
              <InputForm
                schema={schema.note}
                rows={4}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )}
          </>
        }
        onCancle={onCancle}
        onConfirm={handleSubmit(onSubmit)}
      />
    </>
  )
}
